import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ApplyNowSignupModal from "./ApplyNowSignupModal";
import ApplyNowSignInModal from "./ApplyNowSignInModal";
import ApplyNowPrefilledModal from "./ApplyNowPrefilledModal";
import ApplicationSentModal from "./ApplicationSentModal";
import { coachPaths } from "../../../../routes/coach";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../../../../redux/features/find-a-job/reducers/authReducer";

const JobPostDetails = ({ jobListDetails, id, freelancersJobs }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [jobDetails, setJobDetails] = useState(jobListDetails || {});
  const [data, setData] = useState([]);
  const [similarJobs, setSimilarJobs] = useState([]);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isPrefilledModalOpen, setIsPrefilledModalOpen] = useState(false);
  const [isApplicationSentModalOpen, setIsApplicationSentModalOpen] = useState(false);
  const [signupPayload, setSignupPayload] = useState({});
  const hasSidebarData = similarJobs?.length !== 0 || data?.length !== 0;

  useEffect(() => {
    setJobDetails(jobListDetails || {});
  }, [jobListDetails]);

  useEffect(() => {
    if (!freelancersJobs?.length || !jobDetails) return;
    const otherJobs = freelancersJobs?.filter(
      (item) => jobDetails?.created_by === item?.created_by && jobDetails?.id != item?.id
    );
    const similarJobs = freelancersJobs?.filter(
      (item) => jobDetails?.category === item?.category && jobDetails?.id != item?.id
    );
    setData(otherJobs);
    setSimilarJobs(similarJobs);
  }, [jobDetails]);

  const handleUnlockMoreJobs = () => {
    setIsApplicationSentModalOpen(false);
    setIsSignInModalOpen(true);
  };

  const getOnboardingStepBySignupStep = (signupStep) => {
    const step = Number(signupStep);
    if (step === 1) return "profileStep1";
    if (step === 2) return "profileStep2";
    if (step === 3) return "profileStep3";
    if (step === 4) return "profileStep4";
    return null;
  };

  const handleBackToJobs = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(false);
    setIsPrefilledModalOpen(false);
    setIsApplicationSentModalOpen(false);
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    navigate(coachPaths.find_job);
  };

  const renderSidebarJobCard = (item) => (
    <div className="ct_simillar_job_card ct_job_side_card gap-3">
      <div className="d-flex align-items-start justify-content-between gap-2">
        <div className="d-flex align-items-start gap-2">
          {console.log({ item: item?.company_image || "../assets/img/Featured_Jobs_icon_1.svg" })}
          <div className="ct_feature_job_icon">
            <img
              src={item?.company_image || "../assets/img/Featured_Jobs_icon_1.svg"}
              alt={item?.company_name || "Featured job"}
            />
          </div>
          <div>
            <h4 className="ct_fs_18 mb-1 ct_darkblue_text">
              {item?.job_title || ""}
            </h4>
            <ul className="ct_similar_job_key_points d-flex align-items-center gap-2 flex-wrap">
              <li className="ct_fs_12">{item?.company_name || ""}</li>
              <li className="ct_fs_12 d-flex align-items-center gap-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                    fill="#023047"
                  />
                </svg>
                {item?.location || ""}
              </li>
            </ul>
          </div>
        </div>
        <i className="fa-regular fa-eye ct_job_side_eye_icon"></i>
      </div>
      <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
        <span className="ct_job_side_tag">
          {item?.candidate_availability || ""}
        </span>
        <span className="ct_job_side_tag">
          {item?.candidate_location || ""}
        </span>
        <span className="ct_job_side_tag">
          {item?.years_of_experience || 0} Years
        </span>
      </div>
      <p className="ct_job_side_submeta mb-0">2 day ago • 120 Applicants</p>
    </div>
  );

  return (
    <div
      className="modal modal-xl ct_congratulation_modal_fade"
      id={id}
      tabIndex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        className="modal-dialog modal-dialog-centered ct_modal-dialog"
        style={{ maxWidth: "1440px" }}
      >
        <div className="modal-content ct_job_details_modal_v2">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close ct_circle_close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
            <div className="row">
              <div
                className={`${hasSidebarData ? "col-xl-8 col-lg-8" : "col-12"} mb-4 mb-lg-0`}
              >
                <div className="">
                  <div className="d-flex align-items-start justify-content-between gap-3 ct_flex_col_1199  ct_mb_60">
                    <div>
                      <h4 className="ct_fs_32 mb-0 ct_darkblue_text">
                        {jobDetails?.job_title || ""}
                      </h4>
                      <div className="d-flex align-items-center gap-3  mt-4 ct_flex_col_575">
                        <div>
                          <div className="d-flex align-items-center gap-3 ">
                            <div className='ct_feature_job_icon'>
                              <img
                                src={jobDetails?.company_image || "../assets/img/Featured_Jobs_icon_1.svg"}
                                alt={jobDetails?.company_name || "Featured job"}
                              />
                            </div>
                            <h4 className="ct_fs_18 mb-0 ct_darksky_blue_text">
                              {jobDetails?.company_name || ""}{" "}
                            </h4>
                            <div class="ct_fs_14 d-flex align-items-center gap-1">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                  fill="#023047"
                                ></path>
                              </svg>
                              {jobDetails?.location || ""}
                            </div>
                          </div>
                          <div class="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              {jobDetails?.candidate_availability || ""}
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              {jobDetails?.candidate_location || ""}
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              {jobDetails?.years_of_experience || 0} Years
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center  gap-3 ">
                      <button
                        type="button"
                        className="ct_yellow_btn ct_sky_blue_btn ct_white_nowrap ct_border_radius_20 ct_h_44 px-5"
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setIsSignupModalOpen(true);
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                  {jobDetails?.comapny_bio && (
                    <>
                      <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                        About the Company
                      </h4>
                      <p
                        className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                        style={{ maxWidth: "820px" }}
                      >
                        {jobDetails?.comapny_bio || ""}
                      </p>
                    </>
                  )}
                  <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                    About this role
                  </h4>
                  <p
                    className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                    style={{ maxWidth: "820px" }}
                  >
                    {jobDetails?.about_role || ""}
                  </p>
                </div>
                <div className="ct_mt_40">
                  <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                    Industry
                  </h4>
                  <p
                    className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                    style={{ maxWidth: "820px" }}
                  >
                    {jobDetails?.industry || ""}
                  </p>
                </div>
                {jobDetails?.qualification != "" && (
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Qualification
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      {jobDetails?.qualification != "" &&
                        jobDetails?.qualification
                          ?.split(",")
                          ?.map((item) => (
                            <li className="ct_fs_20_new ct_darkblue_text">
                              {item}
                            </li>
                          ))}
                    </ul>
                  </div>
                )}
                {jobDetails?.responsibility != "" && (
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Responsibility
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      {jobDetails?.responsibility != "" &&
                        jobDetails?.responsibility
                          ?.split(",")
                          ?.map((item) => (
                            <li className="ct_fs_20_new ct_darkblue_text">
                              {item}
                            </li>
                          ))}
                    </ul>
                  </div>
                )}
                {jobDetails?.requirement != "" && (
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Requirement
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      {jobDetails?.requirement != "" &&
                        jobDetails?.requirement
                          ?.split(",")
                          ?.map((item) => (
                            <li className="ct_fs_20_new ct_darkblue_text">
                              {item}
                            </li>
                          ))}
                    </ul>
                  </div>
                )}
              </div>
              {hasSidebarData && (
                <div className="col-xl-4 col-lg-4 mb-4 mb-lg-0 ps-lg-5">
                  {similarJobs?.length != 0 && (
                    <div>
                      <h4 className="ct_fs_24_new mb-4">Similar Jobs</h4>
                      <ul>
                        {similarJobs?.length != 0 &&
                          similarJobs?.map((item) => (
                            <li
                              className="mb-4 ct_cursor_pointer"
                              onClick={() => setJobDetails(item)}
                            >
                              {renderSidebarJobCard(item)}
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                  {data?.length != 0 && (
                    <div className="ct_mt_56">
                      <h4 className="ct_fs_24_new mb-4">
                        Other Jobs From {jobDetails?.company_name || ""}
                      </h4>
                      <ul>
                        {data?.length != 0 &&
                          data?.map((item) => (
                            <li
                              className="mb-4 ct_cursor_pointer"
                              onClick={() => setJobDetails(item)}
                            >
                              {renderSidebarJobCard(item)}
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isSignupModalOpen && (
        <ApplyNowSignupModal
          jobDetails={jobDetails}
          onClose={() => setIsSignupModalOpen(false)}
          onContinue={(payload) => {
            setSignupPayload(payload || {});
            setIsSignupModalOpen(false);
            setIsPrefilledModalOpen(true);
          }}
          onOpenSignIn={() => {
            setIsSignupModalOpen(false);
            setIsSignInModalOpen(true);
          }}
        />
      )}
      {isSignInModalOpen && (
        <ApplyNowSignInModal
          isOpen={isSignInModalOpen}
          onClose={() => setIsSignInModalOpen(false)}
          onBackToJobs={handleBackToJobs}
          onSignIn={(payload) => {
            const nextOnboardingStep = getOnboardingStepBySignupStep(
              payload?.signup_step,
            );
            setIsSignInModalOpen(false);
            if (nextOnboardingStep) {
              dispatch(setRegisterStep(nextOnboardingStep));
              dispatch(setIsFindAJobModal(true));
              return;
            }
            setSignupPayload({
              ...(payload || {}),
              job_id: jobDetails?.id || "",
              job_title: jobDetails?.job_title || "",
              company_name: jobDetails?.company_name || "",
            });
            setIsPrefilledModalOpen(true);
          }}
        />
      )}
      {isPrefilledModalOpen && (
        <ApplyNowPrefilledModal
          isOpen={isPrefilledModalOpen}
          formData={signupPayload}
          onClose={() => setIsPrefilledModalOpen(false)}
          onOpenSignIn={() => {
            setIsPrefilledModalOpen(false);
            setIsSignInModalOpen(true);
          }}
          onSubmit={() => {
            setIsPrefilledModalOpen(false);
            setIsApplicationSentModalOpen(true);
          }}
        />
      )}
      {isApplicationSentModalOpen && (
        <ApplicationSentModal
          isOpen={isApplicationSentModalOpen}
          onClose={() => setIsApplicationSentModalOpen(false)}
          onUnlockMoreJobs={handleUnlockMoreJobs}
        />
      )}
    </div>
  );
};

export default JobPostDetails;
